<template>
    <div class="redirect-page max-content">
        <div class="top" v-if="banner_url">
            <img :src="banner_url"
                alt="">
        </div>
        <div class="main">
            <div class="icon">
                <img src="https://cdn.edstatic.com/203012120000/50d03fc5e863ad2edda4f84289a9c4f5/2026/04/8354c3a4-9114-4033-85ce-a858e283424d.png"
                    alt="">
            </div>
            <div class="info">
                欢迎参加第十一届血管创新大会<br>
                《 VINNOVA2026 》<br>
                请点击下方按钮进入会议投稿系统提交您的讲题
            </div>
            <div class="btn" @click="goToVinnova">点击此处进入会议投稿页面</div>
            <p class="contact">如有疑问，请联系大会组委会</p>
            <div class="bottom">
                <p>沪ICP备11005620号-95</p>
                <p>上海翼得营销策划有限公司</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
// import { PersoanalUserInfo, topics, inviteCode } from '../config/interface.js'
export default {
    data() {
        return {
            id:674,
            banner_url:''
        }
    },
    created() {
        this.getSetting();
    },
    methods: {
        getSetting() {
            const url = 'webapi/meetings/' + this.id + '/collects';
            let params = {};
            const method = 'GET';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.banner_url = data.banner;
                       
                    }
                })
        },
        goToVinnova() {
            window.location.href = '/vascularNews/subject/collection?meeting_id=674';
        }
    }
}
</script>
<style lang="scss" scoped>
.redirect-page {
    background: #F0F4F8;
    width: 100%;
    min-height: 100vh;

    .top {
        img {
            width: 100%;
        }
    }

    .main {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-top: 10%;
        align-items: center;
        gap: 25px;

        .icon {
            width: 65px;
            height: 65px;
            border-radius: 50%;
            background: #E6EAEE;
            display: flex;
            align-items: center;
            justify-content: center;
            

            img {
                width: 20px;
                height: 24px;
            }
        }
        .info{
            color: #430B7A;
            text-align: center;
            line-height: 25px;
            font-size: 12px;
        }
        .btn{
            background: linear-gradient(270deg, #8626E5 0%, #45097B 98%);
            box-shadow: 0px 5px 10px 0px rgba(95, 70, 124, 0.4);
            width: 80%;
            height: 50px;
            border-radius: 10px;
            line-height: 50px;
            text-align: center;
            color: #ffffff;
            font-size: 14px;
        }
        .contact{
            color: #ACA0B9;
            font-size: 12px;
        }
        .bottom{
            position: absolute;
            bottom: 0;
            width: 100%;
            background: #ffffff;
            padding: 30px;
            p{
                color: #999999;
                text-align: center;
                font-size: 12px;
            }

        }
        @media screen and (min-width: 700px) {
            .bottom{
                position: relative;
                margin-top: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/RedirectPage.vue